<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-3" >
                <template #default>   <m-single-content-conditional-1 v-bind='{...{"conditions":[{"sourceType":"category","sourceItem":"14","selectedComponent":"mSinglePost201","commentCard":"mCommentCard2","defaultCommentRate":"true"},{"sourceType":null,"sourceItem":null,"selectedComponent":"SinglePost202","commentCard":"mCommentCard2","defaultCommentRate":"true"}]},...{}}' :style='""' class="" ></m-single-content-conditional-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSingleContentConditional1 from '@moeinmdn/miw-alpha-components/src/package/ConditionalComponent/SingleContentConditional1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSingleContentConditional1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
